import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import PURCHASEIRQRealEstateAgentView from "../views/IrqRealEstateAgentView";
import AppRoutes from "../config/AppRoutes";
import ApiConfig from "../config/ApiConfig";
import { getUserId } from "../util/storage/accessTokenStorage";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, string } from "yup";
import StatusCheck from "../components/StatusCheck";

class PurchaseIrqRealEstateAgentPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="purchaseIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            hasRealEstateAgent: string().required(),
          })}
        >
          <PURCHASEIRQRealEstateAgentView
            content={contentMap.PurchaseIrqRealEstateAgentPage}
            navigationsAway={customNavigationMap.PurchaseIrqRealEstateAgentPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(PurchaseIrqRealEstateAgentPage);
